import { Link } from "react-router-dom";

export default function PrivacyPage() {
    return (
        <div
            data-testid="privacy-page"
            className="min-h-screen bg-[#F4F1EA] text-[#1B2A41] font-mont"
        >
            <header className="border-b border-[#1B2A41]/10 bg-[#F4F1EA]/80 backdrop-blur">
                <div className="max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16 py-6 flex items-center justify-between">
                       <Link
                        to="/"
                        data-testid="privacy-back-link"
                        className="text-[11px] tracking-[0.4em] uppercase font-semibold text-[#1B2A41]/70 hover:text-[#C46342] transition-colors"
                    >
                        ← Внутри
                    </Link>
                    <span className="text-[11px] tracking-[0.32em] uppercase text-[#1B2A41]/45">
                           Политика конфиденциальности
                    </span>
                </div>
            </header>

            <main className="max-w-3xl mx-auto px-6 sm:px-10 lg:px-16 py-20 sm:py-28">
                <h1
                    data-testid="privacy-title"
                    className="text-4xl sm:text-5xl lg:text-6xl tracking-[-0.03em] text-[#1B2A41] font-extralight leading-[1.05] mb-12"
                >
                    Политика в отношении обработки персональных данных{" "}
                    <span className="font-semibold">(Политика конфиденциальности)</span>
                </h1>

                <div className="space-y-8 text-base leading-[1.7] text-[#1B2A41]/85 font-light">
                    <div>
                        <h2 className="font-semibold mb-2">1. Общие положения</h2>
                        <p>
                            Настоящая Политика определяет порядок обработки и защиты персональных данных пользователей (далее — Пользователь), оставляющих заявки через форму обратной связи на сайте и в Telegram-боте (далее — Сайт).
                        </p>
                        <p>
                            Оператором персональных данных является Индивидуальный предприниматель Кулакова Елена Васильевна (ИНН 540725616854, ОГРНИП 321547600122247) (далее — Оператор) [152-ФЗ].
                        </p>
                    </div>

                    <div>
                        <h2 className="font-semibold mb-2">2. Цели и правовые основания обработки данных</h2>
                        <p>
                            Оператор обрабатывает персональные данные Пользователей исключительно в следующих целях [152-ФЗ]:
                        </p>
                        <p>
                            Заключение и исполнение договора: обработка запросов, осуществление первого контакта, консультирование и подготовка коммерческих предложений по инициативе Пользователя (на основании п. 2 ч. 1 ст. 6 ФЗ № 152-ФЗ).
                        </p>
                        <p>
                            Продвижение товаров, работ и услуг на рынке: информирование Пользователя о предложениях Оператора (на основании согласия Пользователя, п. 1 ч. 1 ст. 6 ФЗ № 152-ФЗ).
                        </p>
                    </div>

                    <div>
                        <h2 className="font-semibold mb-2">3. Перечень обрабатываемых данных</h2>
                        <p>
                            Через форму обратной связи на Сайте могут собираться следующие данные: фамилия, имя, отчество, номер телефона, адрес электронной почты (email), имя пользователя (username) в Telegram [152-ФЗ].
                        </p>
                    </div>

                    <div>
                        <h2 className="font-semibold mb-2">4. Порядок и условия обработки (транспорт и хранение)</h2>
                        <p>
                            Сбор персональных данных осуществляется на Сайте, откуда они по защищенному протоколу HTTPS направляются напрямую на электронную почту Оператора.
                        </p>
                        <p>
                            Пользователь соглашается с тем, что Оператор вправе поручить хранение персональных данных третьим лицам, а именно: ООО «ЯНДЕКС» (ИНН 7736050003), на защищенных серверах которого в пределах Российской Федерации размещен электронный почтовый ящик Оператора [152-ФЗ].
                        </p>
                        <p>
                            Персональные данные не передаются иным третьим лицам, за исключением случаев, прямо предусмотренных законодательством РФ. Трансграничная передача данных не осуществляется [152-ФЗ].
                        </p>
                    </div>

                    <div>
                        <h2 className="font-semibold mb-2">5. Сроки обработки и уничтожение данных</h2>
                        <p>
                            Обработка данных прекращается при достижении целей обработки, истечении срока действия согласия Пользователя или при отзыве согласия [152-ФЗ]. Направленные данные удаляются из почтового сервиса в течение 10 рабочих дней с момента получения требования Пользователя [152-ФЗ].
                        </p>
                    </div>

                    <div>
                        <h2 className="font-semibold mb-2">6. Отзыв согласия и контакты</h2>
                        <p>
                            Пользователь вправе в любой момент отозвать свое согласие на обработку персональных данных [152-ФЗ]. Для отзыва согласия или по любым вопросам, связанным с обработкой данных, направьте заявление на адрес электронной почты:{" "}
                            <a
                                href="mailto:elena@vnutri.team"
                                className="vnutri-link text-[#C46342] font-medium"
                            >
                                elena@vnutri.team
                            </a>.
                        </p>
                    </div>
                </div>
            </main>
        </div>
    );
}
